<template>
  <div class="resume-model">
    <div class="title">
      <i class="iconfont iconfile-text"></i>
      <span>简历模板</span>
    </div>
    <div class="menu" v-for="(item, index) in templates" :key="index">
      <div class="info">
        <div class="picture">
          <img :src="templateImages[item.en]" alt="">
        </div>
        <div class="content">
          <div class="name">{{item.cn}}</div>
          <div class="num">4321098人使用</div>
        </div>
      </div>
      <div class="message">
        {{item.temp_desc}}
      </div>
      <div class="btn">
        <button v-if="item.cn_img" @click="selectTemplate(item.cn_img, item.en, 'cn')">中文模板</button>
        <button v-if="item.en_img" @click="selectTemplate(item.en_img, item.en, 'en')">英文模板</button>
        <button v-if="item.en_img1" @click="selectTemplate(item.en_img1, item.en1, 'en')">申请硕士</button>
        <button v-if="item.en_img2" @click="selectTemplate(item.en_img2, item.en2, 'en')">申请本科</button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapGetters} from 'vuex';
import {TEMPLATE_IMAGES} from '@/assets/js/const';
export default {
  name: 'resumeTemplateRight',
  props: {
    templates: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      templateImages: TEMPLATE_IMAGES
    }
  },
  methods: {
    selectTemplate(img, token, type) {
      let alertData = {
        show: true,
        type: 'job',
        jobImage: img,
        jobToken: token,
        jobType: type
      };
      this.$store.dispatch('app/setAlertData', alertData);
    }
  },
}
</script>
<style lang="scss" scoped>
  .resume-model {
    background: #fff;
    .title {
      font-size: 14px;
      padding: 20px 13px 10px;
      color: #404040;
      .iconfont {
        margin-right: 2px;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .menu {
      min-height: 110px;
      border-bottom: 1px solid #F0F0F0;
      margin: 0 16px;
      position: relative;
      overflow: hidden; // bfc
      .info {
        display: flex;
        align-items: center;
        margin-top: 14px;
        .picture {
          width: 40px;
          height: 40px;
          // background: #ccc;
          margin-right: 6px;
          img {
            width: 110%;
            margin: 0 -5%;
          }
        }
        .content {
          .num {
            color: #909090;
            margin-top: 6px;
          }
        }
      }
      .message {
        color: #606060;
        font-size: 12px;
        line-height: 18px;
        margin-top: 12px;
        margin-bottom: 10px;
      }
      &:last-child {
        border: none;
      }
      &:hover .btn {
        display: flex;
      }
      .btn {
        display: none;
        width: 100%;
        height: calc(100% - 10px);
        background: #F5F5F7;
        position: absolute;
        top: 5px;
        left: 0;
        z-index: 2;
        justify-content: center;
        align-items: center;
        button {
          width: 98px;
          height: 30px;
          border: 1px solid #ff4f4c;
          color: #ff4f4c;
          font-size: 14px;
          border-radius: 2px;
          background: #fff;
          &:hover {
            background: #ff4f4c;
            color: #fff;
          }
          &:nth-child(2) {
            margin-left: 10px;
          }
        }
      }
    }
  }
</style>